import { render, staticRenderFns } from "./PrivateAdStatus.vue?vue&type=template&id=0eb069ea&scoped=true&"
import script from "./PrivateAdStatus.vue?vue&type=script&lang=js&"
export * from "./PrivateAdStatus.vue?vue&type=script&lang=js&"
import style0 from "./PrivateAdStatus.vue?vue&type=style&index=0&id=0eb069ea&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb069ea",
  null
  
)

export default component.exports